

















































































































































































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDocumentAlert, IDocumentImageSource, ExternalValidationResults, DocumentEditToolControl } from "../../../../domain/document";
import { IDrawableItemEditable, EditingDocument } from "..";
import { ModelEditableMixin, TabContainableMixin } from "../../../system/mixins";
import CacheableComponent from "../../../system/CacheableComponent.vue";
import TabSelector from "../../../system/selectors/TabSelector.vue";
import DebugTool from "../../../developer/document/editor/DebugTool.vue";
import { DeveloperPresentableMixin } from "../../../developer/mixins";
import { ITabDefinition } from "./tools/ITabDefinition";
import EditTool from "./tools/EditTool.vue";
import FixedPhraseTool from "./tools/FixedPhraseTool.vue";
import ClaioContentsTool from "./tools/ClaioContentsTool.vue";
import ClaioSchemaTool from "./tools/ClaioSchemaTool.vue";
import ClipboardTool from "./tools/ClipboardTool.vue";
import InjectedTool from "./tools/InjectedTool.vue";
import DocumentViewTool from "./tools/DocumentViewTool.vue";
import { DocumentStructureEditableMixin, DocumentAttributesEditableMixin } from "../mixins";
import ReferenceFileMenu from "./ReferenceFileMenu.vue";
import AlertTool from "./tools/AlertTool.vue";
import AiPhraseTool from "./tools/AiPhraseTool.vue";
import { DomainRegistry } from "../../../../domain";
import { IToolTabDefinition } from "./IToolTabDefinition";
import ExternalImageTool from "./tools/ExternalImageTool.vue";
import OcojoContentsTool from "./tools/OcojoContentsTool.vue";
import BookmarkTool from "./tools/BookmarkTool.vue";
import { CommentTool } from "./tools";
import { InitialAlert } from "../../../../domain/document/alerts";

@Component({
  components: {
    TabSelector,
    CacheableComponent,
    EditTool,
    FixedPhraseTool,
    ClaioContentsTool,
    ClaioSchemaTool,
    ClipboardTool,
    DebugTool,
    InjectedTool,
    DocumentViewTool,
    AlertTool,
    AiPhraseTool,
    ReferenceFileMenu,
    ExternalImageTool,
    OcojoContentsTool,
    CommentTool,
    BookmarkTool,
  },
})
export default class ToolContainer extends Mixins(ModelEditableMixin, TabContainableMixin, DocumentStructureEditableMixin, DocumentAttributesEditableMixin, DeveloperPresentableMixin) {
  $refs!: {
    documentViewTool: DocumentViewTool,
  };

  editingSource: EditingDocument;
  static readonly Tabs: {[key: string]: IToolTabDefinition} = {
      edit: {
        name: "edit",
        description: "文書に図形や文字を描画するツールパレットやオブジェクト編集UIを表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "編集",
      },
      fixedPhrase: {
        name: "fixedPhrase",
        description: "登録されている定型文を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "定型文",
      },
      claio: {
        name: "claio",
        description: "Claioに登録されている画像を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "画像",
      },
      ocojo: {
        name: "ocojo",
        description: "デジカメ画像の一覧を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "デジカメ画像",
      },
      claioSchema: {
        name: "schema",
        description: "Claioシェーマの一覧を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "シェーマ",
      },
      clipboard: {
        name: "clipboard",
        description: "クリップボードの履歴を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "クリップボード",
      },
      comment: {
        name: "comment",
        description: "各種コメントを表示します。",
        width: "600px",
        height: "400px",
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: null,
        title: "コメント",
      },
      createdReport: {
        name: "createdReport",
        description: "編集中文書の患者の作成済文書を表示します。",
        width: "600px",
        height: "400px",
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: null,
        title: "作成済文書",
      },
      alert: {
        name: "alert",
        description: "発生した警告を一覧で表示します。登録前の事前検証もできます。",
        width: "600px",
        height: "400px",
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: null,
        title: "警告確認",
      },
      injected: {
        name: "injected",
        description: "文書作成時に注入された値の情報を表示します。",
        width: "600px",
        height: "400px",
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: null,
        title: "注入内容",
      },
      aiPhrase: {
        name: "aiPhrase",
        description: "選択した診療録から生成AIで診療情報を抽出して整形した文章を文書に追加できます。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "生成AI定型文",
      },
      debug: {
        name: "debug",
        description: "オブジェクトの情報を表示します。デバッグモードの時のみ表示されます。",
        width: "600px",
        height: "400px",
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: null,
        title: "debug",
      },
      externalImage: {
        name: "externalImage",
        description: "外部連携画像の一覧を表示します。",
        width: "calc(100vw - 1022px)",
        height: "20vh",
        minWidth: "258px",
        minHeight: "258px",
        maxWidth: "370px",
        maxHeight: "370px",
        title: "外部連携画像",
      },
      bookmark: {
        name: "bookmark",
        description: "ブックマークを一覧で表示します。",
        width: "100%",
        height: null,
        minWidth: null,
        minHeight: null,
        maxWidth: null,
        maxHeight: "142px",
        title: "ブックマーク",
      },
  };

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly editTab: IToolTabDefinition = ToolContainer.Tabs.edit;
  readonly fixedPhraseTab: IToolTabDefinition = ToolContainer.Tabs.fixedPhrase;
  readonly claioTab: IToolTabDefinition = ToolContainer.Tabs.claio;
  readonly ocojoTab: IToolTabDefinition = ToolContainer.Tabs.ocojo;
  readonly claioSchemaTab: IToolTabDefinition = ToolContainer.Tabs.claioSchema;
  readonly clipboardTab: IToolTabDefinition = ToolContainer.Tabs.clipboard;
  readonly commentTab: IToolTabDefinition = ToolContainer.Tabs.comment;
  readonly createdReportTab: IToolTabDefinition = ToolContainer.Tabs.createdReport;
  readonly alertTab: IToolTabDefinition = ToolContainer.Tabs.alert;
  readonly injectedTab: IToolTabDefinition = ToolContainer.Tabs.injected;
  readonly aiPhraseTab: IToolTabDefinition = ToolContainer.Tabs.aiPhrase;
  readonly debugTab: IToolTabDefinition = ToolContainer.Tabs.debug;
  readonly externalImageTab: IToolTabDefinition = ToolContainer.Tabs.externalImage;
  readonly bookmarkTab: IToolTabDefinition = ToolContainer.Tabs.bookmark;

  @Prop()
  enableTabs: IToolTabDefinition[];

  @Prop({ default: "right" })
  tabPosition: string;

  @Prop()
  defaultTab: IToolTabDefinition;

  @Prop()
  additionalTabs: IToolTabDefinition[];

  @Prop()
  additionalDocumentViewToolTabs: ITabDefinition[];

  @Prop()
  maxWidth: number;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  @Prop()
  validateWithExternalValidationUrl: () => Promise<ExternalValidationResults>;

  data(): any {
    return {
      isCreatedReportReady: !(this.defaultTab && this.defaultTab.name === "createdReport"), // この時点ではthis.createdReportTabはundefinedのためnameで判断
      oldSelectedTab: null as { name: string, description: string },
    };
  }
  isCreatedReportReady: boolean;
  oldSelectedTab: { name: string, description: string };

  get focusedObject(): IDrawableItemEditable {
    return this.readPropertyOrDefault(s => s.lastFocusedObject, null);
  }

  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }

  get departmentId(): string {
    return this.$store.getters.department
      ? this.$store.getters.department.id
      : null;
  }

  get formatProperty(): string {
    return this.isDocumentAlreadyInitialized
      ? this.formatOriginalId.toString()
      : "";
  }

  get formatName(): string {
    return this.isDocumentAlreadyInitialized
      ? this.editingSource.source.attributes.format.name
      : "";
  }

  get orderNo(): string {
    return this.isDocumentAlreadyInitialized
      ? this.editingSource.source.attributes.orderNo
      : null;
  }

  get containerClass(): any {
    return [
      "tool-container-root",
      "tool-container-root-" + this.tabPosition,
    ];
  }

  get containerTransitionName(): "expand-width" | "expand-height" {
    return this.isLayoutHorizontal
      ? "expand-width"
      : "expand-height";
  }

  get containerStyle(): any {
    const style = this.tabUsedForContainerStyle as IToolTabDefinition;
    if (!style) {
      return null;
    }
    return this.isLayoutHorizontal
      ? {
        width: style.width,
        height: "100%",
        minWidth: !this.isTransitioning ? style.minWidth : null,
        maxWidth: !!this.maxWidth ? (this.maxWidth + "px") : !!style.maxWidth ? style.maxWidth : style.width, // transitionをmax-widthで行うために値が必要
      }
      : {
        width: "100%",
        height: style.height,
        minHeight: !this.isTransitioning ? style.minHeight : null,
        maxHeight: !!style.maxHeight ? style.maxHeight : style.height,  // transitionをmax-heightで行うために値が必要
      };
  }

  get tabUsedForContainerStyle(): { name: string, description: string } {
    return !!this.selectedTab
      ? this.selectedTab
      : this.oldSelectedTab;
  }

  get isLayoutHorizontal(): boolean {
    return (this.tabPosition === "right")
        || (this.tabPosition === "left");
  }

  get tabLayoutClass(): string {
    return !this.isLayoutHorizontal
      ? "horizontal"
      : "vertical";
  }

  get claioTabName(): string {
    return this.$configuration.behavior.document.editor.contents.claio.name;
  }

  get claioDescription(): string {
    return this.$configuration.behavior.collaboration.claio.imageName;
  }

  get externalImageTabName(): string {
    return this.$configuration.behavior.document.editor.contents.externalImage.name;
  }

  get externalImageDescription(): string {
    return this.$configuration.behavior.collaboration.externalImage.imageName;
  }

  get schemaTabName(): string {
    return this.$configuration.behavior.document.editor.contents.schema.name;
  }

  get schemaDescription(): string {
    return this.$configuration.behavior.collaboration.schema.imageName;
  }

  get ocojoTabName(): string {
    return this.$configuration.behavior.document.editor.contents.ocojo.name;
  }

  get ocojoDescription(): string {
    return this.$configuration.behavior.collaboration.ocojo.imageName;
  }

  get editToolControl(): DocumentEditToolControl {
    return (this.editingSource && this.editingSource.attributes)
      ? this.editingSource.attributes.editToolControl
      : null;
  }

  mounted() {
    // tabsがstaticのため、ここでタブの設定を読み込む
    this.setClaioTabSettings();
    this.setExternalImageSettings();
    this.setclaioSchemaSettings();
    this.setOcojoTabSettings();
  }

  created(): void {
    this.initializeTabs();
    if (this.defaultTab) {
      this.selectedTab = Enumerable.from(this.tabs).firstOrDefault(t => t.name === this.defaultTab.name);
    }
    this.startClipboardService();
  }

  @Watch("enableTabs")
  onEnableTabsUpdated(newValue: IToolTabDefinition[], oldValue: IToolTabDefinition[]): void {
    this.initializeTabs();
  }

  @Watch("selectedTab")
  onSelectedTabChanged(newValue: { name: string, description: string }, oldValue: { name: string, description: string }) {
    this.oldSelectedTab = oldValue;
    if (newValue && newValue.name === this.createdReportTab.name) {
      if (!this.isCreatedReportReady) {
        this.isCreatedReportReady = true;
        return;
      }
      if (this.$refs.documentViewTool && !this.$refs.documentViewTool.isDocumentSelected && this.patientAttribute) {
        this.$refs.documentViewTool.showDocumentSelectDialog();
      }
    }
  }

  initializeTabs(): void {
    const selectedTab = this.selectedTab;
    this.tabs = Enumerable.from(this.additionalTabs ? this.additionalTabs : [])
      .concat([
      this.isEditEnable ? ToolContainer.Tabs.edit : null,
      this.isFixedPhraseEnable ? ToolContainer.Tabs.fixedPhrase : null,
      this.isClaioEnable ? ToolContainer.Tabs.claio : null,
      this.isOcojoEnable ? ToolContainer.Tabs.ocojo : null,
      this.isClaioSchemaEnable ? ToolContainer.Tabs.claioSchema : null,
      this.isClipboardEnable ? ToolContainer.Tabs.clipboard : null,
      this.isCommentEnable ? ToolContainer.Tabs.comment : null,
      this.isCreatedReportEnable ? ToolContainer.Tabs.createdReport : null,
      this.isAlertEnable ? ToolContainer.Tabs.alert : null,
      this.isInjectedEnable ? ToolContainer.Tabs.injected : null,
      this.isAiPhraseEnable ? ToolContainer.Tabs.aiPhrase : null,
      this.isDebugEnable ? ToolContainer.Tabs.debug : null,
      this.isExternalImageEnable ? ToolContainer.Tabs.externalImage : null,
      this.isBookmarkEnable ? ToolContainer.Tabs.bookmark : null,
    ])
    .where(t => !!t)
    .toArray();
    // タブが自動で閉じてしまうので、選択中のタブがある場合はそれを選択しなおしている
    if (selectedTab) {
      this.selectedTab = Enumerable.from(this.tabs).firstOrDefault(t => t.name === selectedTab.name);
    }
  }

  startClipboardService(): void {
    if (!this.isClipboardEnable) { return; }
    const service = DomainRegistry.system.getClipboardService();
    service.start()
    .catch(e => {
      this.$warn("クリップボード", "クリップボード監視サービスの開始に失敗しました。", e);
    });
  }

  setClaioTabSettings(): void {
    ToolContainer.Tabs.claio.title = this.claioTabName;
    ToolContainer.Tabs.claio.description = this.claioDescription + "に登録されている画像を表示します。";
  }

  setExternalImageSettings(): void {
    ToolContainer.Tabs.externalImage.title = this.externalImageTabName;
    ToolContainer.Tabs.externalImage.description = this.externalImageDescription + "の一覧を表示します。";
  }

  setclaioSchemaSettings(): void {
    ToolContainer.Tabs.claioSchema.title = this.schemaTabName;
    ToolContainer.Tabs.claioSchema.description = this.schemaDescription + "の一覧を表示します。";
  }

  setOcojoTabSettings(): void {
    ToolContainer.Tabs.ocojo.title = this.ocojoTabName;
    ToolContainer.Tabs.ocojo.description = this.ocojoDescription + "に登録されている画像を表示します。";
  }

  private get isEditEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.edit);
  }

  private get isFixedPhraseEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.fixedPhrase);
  }

  private get isClaioEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.claio)
        && this.$configuration.behavior.document.editor.contents.claio.isEnable;
  }

  private get isClaioSchemaEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.claioSchema)
        && this.$configuration.behavior.document.editor.contents.schema.isEnable;
  }

  private get isClipboardEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.clipboard)
        && this.$configuration.behavior.document.editor.contents.clipboard.isEnable;
  }

  private get isDebugEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.debug)
        && this.isDeveloperMode;
  }

  private get isCommentEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.comment);
  }

  private get isCreatedReportEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.createdReport);
  }

  private get isAlertEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.alert);
  }

  private get isInjectedEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.injected);
  }

  private get isAiPhraseEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.aiPhrase)
        && this.$configuration.behavior.document.editor.contents.aiPhrase.isEnable
        && !DomainRegistry.instance.user.getRestrictionService().isRestricted("aiPhrase");
  }

  private get isExternalImageEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.externalImage)
        && this.$configuration.behavior.document.editor.contents.externalImage.isEnable;
  }

  private get isOcojoEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.ocojo)
        && this.$configuration.behavior.document.editor.contents.ocojo.isEnable;
  }

  private get isBookmarkEnable(): boolean {
    return this.containsTab(ToolContainer.Tabs.bookmark);
  }

  private containsTab(tab: IToolTabDefinition): boolean {
    return (0 <= this.enableTabs.indexOf(tab));
  }

  shouldCreateAdditionalContent(): boolean {
    return this.additionalTabs
        && (0 < this.additionalTabs.length);
  }

  shouldShowAdditionalContent(): boolean {
    return this.selectedTab
        && Enumerable.from(this.additionalTabs).any(t => this.selectedTab.name === t.name)
        && !this.isTransitioning;
  }

  @Watch("isDeveloperMode")
  onDeveloperModeUpdated(newValue: boolean, oldValue: boolean): void {
    this.initializeTabs();
  }

  get alerts(): IDocumentAlert[] {
    return this.readPropertyOrDefault(s => s.alerts, []);
  }

  @Watch("alerts")
  onAlertsUpdated(newValue: IDocumentAlert[], oldValue: IDocumentAlert[]): void {
    if (this.isAlertEnable && (newValue !== oldValue) && newValue && Enumerable.from(newValue).where(a => !(a instanceof InitialAlert)).any(a => a.isError || a.isConfirmDenied)) {
      this.selectedTab = ToolContainer.Tabs.alert; 
    }
  }

  onQuoteCompleted(): void {
    if (this.$configuration.behavior.document.editor.contents.documentView.shouldCloseAfterQuotation) {
      this.clearTabSelection();
    }
  }
}
